import { useEffect } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
// Defines window.BMWind, the wind streaks the Wind map layer draws; imported here too so the
// panel does not depend on the time bar having loaded it.
import '../../../../../lib/timeLayers/wind-particles'
import { googleWindMap } from '../../../../../lib/timeLayers/googleWindMap'
import { fetchIndexAt } from '../../../../../lib/timeLayers/indexService'
import { DRIFT_WIND_LAYER, nearestWindFieldUrl, tilesBase } from '../../../../../lib/timeLayers/timeline'

const FALLBACK_BASE = `https://pmtiles.basemap.com/tiles/${DRIFT_WIND_LAYER}/`
const FIELD_DEBOUNCE_MS = 250

// The Wind layer's tile host, from its catalog row when the user has it, else the shared host.
export function windBase(layersDictionary) {
  const row = Object.values(layersDictionary || {})
    .find(l => typeof l.cloudfrontUrl === 'string' && l.cloudfrontUrl.includes(`/tiles/${DRIFT_WIND_LAYER}/`))
  return (row && tilesBase(row.cloudfrontUrl)) || FALLBACK_BASE
}

// The forecast wind for HuntWind's hour as the Wind layer's particle streaks on the 2D map: the usa_wind
// frame nearest the hour, through the same shared engine the weather time bar uses.
function WindFlow({ timeStamp, mapReference, layersDictionary }) {
  const base = windBase(layersDictionary)
  const time = timeStamp ? moment.utc(timeStamp).valueOf() : Date.now()

  useEffect(() => {
    const BMWind = window.BMWind
    if (!BMWind || !mapReference) return undefined
    BMWind.install(googleWindMap(mapReference))
    BMWind.setEnabled(true)
    return () => {
      BMWind.setField({ url: null })
      BMWind.setEnabled(false)
    }
  }, [mapReference])

  useEffect(() => {
    const BMWind = window.BMWind
    if (!BMWind || !mapReference) return undefined
    let cancelled = false
    const timer = setTimeout(() => {
      fetchIndexAt(base).then(index => {
        if (!cancelled) BMWind.setField({ url: nearestWindFieldUrl(index, base, time), kind: 'wind' })
      })
    }, FIELD_DEBOUNCE_MS)
    return () => { cancelled = true; clearTimeout(timer) }
  }, [base, time, mapReference])

  return null
}

const mapStateToProps = state => ({
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  layersDictionary: state.layersDictionary
})

export default connect(mapStateToProps)(WindFlow)
